import * as React from "react";

import { Client } from "../../../../domain/model/client";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientMypageMainClientForm from "./edit_client/client_mypage_main_client_form";

interface IProps {
  isLoading: boolean;
  client: Client | null;
  handleUpdateClientSubmit: (values: any) => void;
}

const ClientMyPageClientEditComponent: React.FC<IProps> = (props) => {
  const { isLoading, client, handleUpdateClientSubmit } = props;

  const initialValues = { client };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientMypage,
    routeConfig.clientMypageClientEdit,
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <Breadcrumbs breadcrumbItems={breadcrumbItems} />
          <ClientMypageMainClientForm
            // For Redux-Form
            initialValues={initialValues}
            onSubmit={handleUpdateClientSubmit}
            enableReinitialize={true}
          />
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientMyPageClientEditComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_edit_client.tsx